import { Button } from "./button";

type Props = {
  size?: "default" | "sm" | "lg" | "icon" | null | undefined;
  className?: string;
  onClick?: () => void;
  children: React.ReactNode;
};

const IconButton = ({ size, className, onClick, children }: Props) => {
  return (
    <Button
      className={`text-gray-500 hover:text-gray-700 hover:bg-gray-200 bg-transparent p-1 transition-colors w-12 h-12 mx-3 ${
        className || ""
      }`}
      size={size}
      onClick={onClick}
    >
      {children}
    </Button>
  );
};

export default IconButton;
